  import { Component, OnInit,ViewChild } from '@angular/core';
  import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
  import { Router } from '@angular/router';
  import { ToastrService } from 'ngx-toastr';
  import { ApiService } from 'app/shared/services/api.service';
  
  @Component({
    selector: 'app-create-discount',
    templateUrl: './create-discount.component.html',
    styleUrls: ['./create-discount.component.scss']
  })
  export class CreateDiscountComponent implements OnInit {
     @ViewChild('vform') validationForm: FormGroup;
    discountForm:FormGroup;
    discountFormSubmitted:boolean=false
    selectedDiscount:'';
    discountList=[
      { id:1, name:'amount'},
      { id:2, name:'percentage'},
    ]
    constructor(private formBuilder: FormBuilder,
      public toastr: ToastrService,
      public apiService:ApiService,
      private route:Router) {
    
  
       }
  
    ngOnInit(): void {
      this.discountForm=this.formBuilder.group({
      name: ['', Validators.required],
      discount_type: ['', Validators.required],
      amount: ['', Validators.required],
      notes: ['', Validators.required],
      admin_notes: ['', Validators.required],
    })
    }
   
    get rf() {
      return this.discountForm.controls;
    }
    
    submitDiscount(){
      let body={
        name:this.discountForm.controls.name.value,
        discount_type:this.selectedDiscount,
        amount:this.discountForm.controls.amount.value,
        notes:this.discountForm.controls.notes.value,
        admin_notes:this.discountForm.controls.admin_notes.value,
      }
      console.log('discount form val',body)
       this.discountFormSubmitted = true;
       this.apiService.createDiscounts(body).subscribe((res:any)=>{
        if(res.isSuccess ===true){
          console.log('create dis',res)
          this.toastr.success(res.message)
          this.route.navigate(['/discounts/discount-list'])
        }
        else{
          this.toastr.error(res.error)
        }
       })
        
  }
  getDiscountId(event:any){
    // this.selectedDiscount=event.target.value
    console.log('discount id',this.selectedDiscount)
  }

  back(){
  this.route.navigate(['/discounts/discount-list'])    

  } 
  }